import { render, staticRenderFns } from "./StoreNav.vue?vue&type=template&id=a452779e&scoped=true"
import script from "./StoreNav.vue?vue&type=script&lang=js"
export * from "./StoreNav.vue?vue&type=script&lang=js"
import style0 from "./StoreNav.vue?vue&type=style&index=0&id=a452779e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a452779e",
  null
  
)

export default component.exports